<template>
  <div
    id="app"
    style="height: 100%"
  >
    <router-view />
    <Toast
      :position="screenWidth > 425 ? 'top-center' : 'bottom-center'"
      :style="screenWidth > 425 ? 'top: 4rem' : 'bottom: 0.03rem' "
      :breakpoints="{'425px': {width: '100%'}}"
    />
  </div>
</template>


<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import store from "@/core/services/store";
import { mapGetters } from "vuex";
import Toast from 'primevue/toast'
export default {
  name: "SohaATS",

  components: {
    Toast
  },

  watch: {
    userInfo: {
      handler(user) {
        if (user?.roleId) {
          store.dispatch("fetchMenu");
        }
      },
      immediate: true,
    },
  },
  
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    // this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  },

  computed: {
    ...mapGetters(["userInfo", "screenWidth"]),
  },
};
</script>

<style lang="scss">
// 3rd party plugins css

@import 'primeicons/primeicons.css';
@import '@/assets/css/primevue-fix.css';
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/style.vue.rtl";
@import "assets/css/matter-0.2.2.css";
@import '@/assets/css/public.css';
</style>
